module.exports = __webpack_public_path__ + "static/media/whatWeOfferFreeMarket.9db8f055.svg";